import { useMemo, useState } from 'react';
import { endOfDay, startOfDay } from 'date-fns';
import useJobs from '@/hooks/runner/useJobs';
import { useGoogleCalendarEvents } from './useGoogleCalendarEvents';
import { useCalendlyEvents } from './useCalendlyEvents';

/**
 * How many jobs, Google Calendar events and Calendly meetings fall on today.
 * Reminders are left out because they have their own count.
 */
export const useTodayEventCount = (): number => {
	const [today] = useState(() => new Date());
	const { jobs } = useJobs();
	const google = useGoogleCalendarEvents({
		currentDate: today,
		currentView: 'day',
		syncJobs: false,
	});
	const calendly = useCalendlyEvents({
		currentDate: today,
		currentView: 'day',
	});

	const todayJobCount = useMemo(() => {
		const dayStart = startOfDay(today);
		const dayEnd = endOfDay(today);
		return jobs.filter((job: { startDate?: string; endDate?: string }) => {
			if (!job.startDate) return false;
			const start = new Date(job.startDate);
			const end = new Date(job.endDate || job.startDate);
			return start <= dayEnd && end >= dayStart;
		}).length;
	}, [jobs, today]);

	return todayJobCount + google.events.length + calendly.events.length;
};
